<div class="content_wrapper">
    <app-text contentId="6Cg7ptnlb6eLZvr8ZbNWnm"></app-text>
</div>